import type { Category } from "@/mocks/categories";

export interface FilterState {
  sub: string;
  time: string;
  type: string;
}

interface Props {
  category: Category;
  filters: FilterState;
  onChange: (next: Partial<FilterState>) => void;
  onReset: () => void;
}

const timeOptions = [
  { value: "all", label: "全部时间" },
  { value: "1d", label: "一天内" },
  { value: "7d", label: "一周内" },
  { value: "30d", label: "一个月内" },
];

const typeOptions = [
  { value: "all", label: "全部类型" },
  { value: "news", label: "新闻" },
  { value: "video", label: "视频" },
  { value: "report", label: "专项报道" },
];

export default function FilterSidebar({ category, filters, onChange, onReset }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h5 className="text-sm font-bold text-foreground-900 mb-3 flex items-center gap-2">
          <i className="ri-price-tag-3-line text-primary-500" />
          子分类
        </h5>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onChange({ sub: "" })}
            className={`px-3 py-1.5 rounded-md text-xs md:text-sm whitespace-nowrap transition-colors ${
              filters.sub === ""
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            全部
          </button>
          {category.subcategories.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => onChange({ sub: s })}
              className={`px-3 py-1.5 rounded-md text-xs md:text-sm whitespace-nowrap transition-colors ${
                filters.sub === s
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      <div>
        <h5 className="text-sm font-bold text-foreground-900 mb-3 flex items-center gap-2">
          <i className="ri-calendar-line text-primary-500" />
          发布时间
        </h5>
        <div className="space-y-2">
          {timeOptions.map((o) => (
            <label key={o.value} className="flex items-center gap-2 text-sm text-foreground-600 cursor-pointer">
              <input
                type="radio"
                name="time-filter"
                checked={filters.time === o.value}
                onChange={() => onChange({ time: o.value })}
                className="accent-primary-500 w-4 h-4"
              />
              {o.label}
            </label>
          ))}
        </div>
      </div>

      <div>
        <h5 className="text-sm font-bold text-foreground-900 mb-3 flex items-center gap-2">
          <i className="ri-file-list-3-line text-primary-500" />
          内容类型
        </h5>
        <div className="space-y-2">
          {typeOptions.map((o) => (
            <label key={o.value} className="flex items-center gap-2 text-sm text-foreground-600 cursor-pointer">
              <input
                type="radio"
                name="type-filter"
                checked={filters.type === o.value}
                onChange={() => onChange({ type: o.value })}
                className="accent-primary-500 w-4 h-4"
              />
              {o.label}
            </label>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={onReset}
        className="w-full h-10 rounded-md border border-background-300 text-sm text-foreground-600 hover:bg-background-100 whitespace-nowrap flex items-center justify-center gap-2 transition-colors"
      >
        <i className="ri-refresh-line" />
        重置筛选
      </button>
    </div>
  );
}